<template>
    <div class="perspective-lower-bar-input-container">
        <input :class="{'bad-data':badData}" id="distance" type="number" placeholder="Длина, м"
               v-model:value="distance">
    </div>
</template>

<script>
    export default {
        name: "LeftLowerBarPerspective",
        computed: {
            distance: {
                get() {
                    return this.$store.state.UI.distanceBetweenPointsForScale;
                },
                set(value) {
                    if (!value) {
                        console.log(value);
                        return;
                    }
                    if (isNaN(parseFloat(value))) {
                        this.badData = true;
                        return;
                    }
                    this.badData = false;
                    this.$store.commit('UI/DISTANCE_BETWEEN_POINTS_FOR_SCALE', parseFloat(value));
                }
            }
        },
        data() {
            return {badData: false}
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        #distance {
            width: 278px;
            height: 19px;
            padding: 5px;
            border: 1px solid #BDBDBD;
            margin: 11px 40px;
        }
    }

    @media screen and (min-height: 800px) {
        #distance {
            width: 278px;
            height: 19px;
            padding: 10px;
            border: 1px solid #BDBDBD;
            margin: 16px 40px;
        }
    }

    #distance:hover {
        border-color: #828282;
    }

    #distance:focus {
        border-color: #828282;
    }

    .bad-data {
        background-color: #ffd4d4;
    }
</style>
